import React from 'react';
import './cta_banner.css';
import Button from '../button/button';

var _ref = React.createElement(
	'svg',
	{ xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', viewBox: '0 0 16 16' },
	React.createElement('path', { id: 'Path_10', 'data-name': 'Path 10', d: 'M8,0,6.545,1.455l5.506,5.506H0V9.039H12.052L6.545,14.545,8,16l8-8Z', fill: '#e6e6e6' })
);

var CTABanner = function CTABanner(props) {
	var _props$cta = props.cta,
	    text = _props$cta.text,
	    button_text = _props$cta.button_text,
	    button_link = _props$cta.button_link;

	return React.createElement(
		'div',
		{ className: 'cta-banner' },
		React.createElement(
			'h2',
			null,
			text
		),
		React.createElement(Button, {
			url: button_link,
			text: button_text,
			icon: _ref
		})
	);
};

export default CTABanner;